<template>
  <div class="order_detail">
    <nav-bar />
    <search-bar />
    <div class="main fz14" v-if="loading">
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>我的订单</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="info_box">
        <div class="info mb20">
          <div class="fr ac fz12 mt20">
            <div class="center order_list_item">产品信息</div>
            <div class="center order_list_item">产品规格</div>
            <div class="center order_list_item">设备信息</div>
            <div class="center order_list_item">配套工艺</div>
            <div class="center order_list_item">产品价格</div>
            <div class="center order_list_item">数量</div>
            <div class="center order_list_item">小计</div>
          </div>
          <el-divider />
          <div class="order-list fz12">
            <div class="order-item mt20">
              <!--                上-->
              <div class="top">
                <span>{{order_detail.create_time}}</span>
                <span class="ml20 grey">订单编号：{{order_detail.order_no}}</span>
                <span class="ml40 blue" v-html="order_state_decide(order_detail)"></span>
              </div>
              <!--                中-->

              <div class="fr middle">
                <!-- 商品信息 -->
                <div class="order">
                  <div
                    class="fr jc ac order_left"
                    v-for="(goods,i) in order_detail.orderGoodsBeans"
                    :key="i"
                  >
                    <div class="fr afs pl10 pr20 pt20 pb20 order_list_item">
                      <el-image class="goods_img fs mr10" :src="goods.goods_img" alt />
                      <p class>{{goods.goods_name}} {{goods.goods_standard_name}}</p>
                    </div>
                    <div class="center order_list_item"> {{ specNameInit(goods) }}</div>

                    <div class="center order_list_item">{{goods.device_id?goods.device_id:'-'}}</div>

                    <div
                      v-if="goods.goods_type==1"
                      @click="onShowSelectCraft(goods.order_goods_id)"
                      class="center cursor order_list_item blue"
                    >{{goods.goods_craft_price}}</div>
                    <div v-if="goods.goods_type==2" class="center cursor order_list_item bule">-</div>

                    <div class="center order_list_item">￥{{goods.goods_price}}</div>
                    <div class="center order_list_item">{{goods.goods_num}}</div>
                    <div class="center order_list_item red">￥{{goods.goods_total_price}}</div>
                  </div>
                </div>
              </div>

              <!--                下-->
            </div>
          </div>

          <!--线-->
          <el-divider />

          <!--          反馈-->

          <div class="mt30">
            <div class="fr">
              <div>反馈描述：</div>
              <div class="ml20">
                <el-input
                  disabled
                  style="width: 700px"
                  type="textarea"
                  rows="5"
                  placeholder="placeholder"
                  v-model="feedback.feedback_desc"
                ></el-input>
              </div>
            </div>
            <!--反馈图片-->

            <div class="fr mt30">
              <div class>反馈图片</div>
              <div>
                <img
                  class="ml30"
                  style="width: 100px;height: 100px"
                  :src="item"
                  v-for="(item,index) in feedback.feedback_imgs.split(',')"
                  alt
                  :key="index"
                />
              </div>
            </div>
          </div>

          <!--线-->
          <el-divider />

          <!--          反馈回复-->

          <div class="mt30">
            <div class="fr">
              <div>反馈描述：</div>
              <div class="ml20">
                <el-input
                  :disabled="feedback.is_feedback==1?true:false"
                  style="width: 700px"
                  type="textarea"
                  rows="5"
                  placeholder="请输入回复内容"
                  v-model="feedback.feedback_reply"
                ></el-input>
              </div>
            </div>
          </div>
        </div>

        <div class="fr jc ac mt30 mb30">
          <el-button
            @click="replyFeedback"
            type="primary"
            style="width: 315px"
            v-if="!feedback.is_feedback"
          >回复</el-button>
        </div>
      </div>
    </div>
    <footer-bar />

    <!--    弹窗-->

    <el-dialog :show-close="false" :visible.sync="crafts_show">
      <div slot="title" class="fr ac jsb head">
        <p class="fz14 black bold">配套工艺</p>
        <i class="el-icon-close fz14 cursor" @click="crafts_show = false"></i>
      </div>
      <el-table :data="crafts" tooltip-effect="dark" style="width: 100%">
        <el-table-column label="产品规格" header-align="center">
          <template slot-scope="scope">
            <p class="mb10">{{scope.row.craft_name}}</p>

            <el-select
              v-model="scope.row.select_id"
              placeholder="请选择"
              size="mini"
              @change="onCraftSelect(scope.row,scope.$index)"
            >
              <el-option
                v-for="item in scope.row.craftBeans"
                :key="item.craft_id"
                :label="item.craft_name"
                :value="item.craft_id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="specification_price" label="数量" header-align="center" align="center">
          <template slot-scope="scope">
            <p class="mb30"></p>
            <el-input-number size="mini" v-model="scope.row.craft_count" :min="0"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="craft_price" label="价格" header-align="center" align="center">
          <template slot-scope="scope">
            <p class="mb30"></p>
            <p class="blue">￥{{scope.row.craft_price}}</p>
          </template>
        </el-table-column>
      </el-table>
      <!--      <div>-->
      <!--        <p class="fz14 mb10 mt10">其他技术要求</p>-->
      <!--        <el-input-->
      <!--            type="textarea"-->
      <!--            resize="none"-->
      <!--            :rows="5"-->
      <!--            style="width:50%;"-->
      <!--            v-model="craft_remark"-->
      <!--        ></el-input>-->
      <!--      </div>-->
    </el-dialog>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import Upload from "@/components/UploadImg";

export default {
  props: {},
  data() {
    return {
      //工艺弹窗
      crafts_show: false,
      //总的工艺列表
      crafts: [],

      //当前选择的商品id
      current_order_goods_id: "",

      order_detail: {},
      //反馈
      feedback: {
        feedback_imgs: "",
        feedback_reply: ""
      },
      loading: false
    };
  },
  computed: {},
  mounted() {
    this.getOrderDetail();
    this.getCrafts();
    this.getFeedbackDetail();
  },
  methods: {
    //回复质量反馈
    replyFeedback() {
      let param = Object.assign(this.feedback);
      if (!param.feedback_reply) {
        this.$message("请输入回复内容");
        return;
      }
      this.post("orderInterfaces/v1.0/replyOrderFeedback", param).then(res => {
        this.$message("回复成功");
        this.back();
      });
    },

    //获取售后反馈详情
    getFeedbackDetail() {
      let param = {
        order_merchants_id: this.$route.query.order_merchants_id
      };

      this.post(
        "orderInterfaces/v1.0/getOrderMerchantsFeedbackDetail",
        param
      ).then(res => {
        this.feedback = res.data;
        this.feedback.is_feedback = this.$route.query.is_feedback;
      });
    },
    //保存工艺选择
    saveCraftChange() {
      console.log(this.crafts);

      let orderCraftBeans = [];
      this.crafts.forEach(item => {
        let obj = {
          order_craft_id: item.order_craft_id,
          craft_id: item.select_id,
          craft_count: item.craft_count
        };
        orderCraftBeans.push(obj);
      });

      this.order_detail.json.forEach(item => {
        if (this.current_order_goods_id == item.order_goods_id) {
          item.orderCraftBeans = orderCraftBeans;
        }
      });

      //  重新获取价格
      this.checkout();

      //重置工艺选择
      this.getCrafts();

      this.crafts_show = false;
    },
    //显示商品工艺列表
    onShowSelectCraft(order_goods_id) {
      this.current_order_goods_id = order_goods_id;
      let json = this.order_detail.json;
      let goods_crafts = [];
      json.forEach(item => {
        if (item.order_goods_id == order_goods_id) {
          goods_crafts = item.orderCraftBeans;
        }
      });

      //  选中  工艺列表的数据

      this.crafts.forEach(item => {
        item.craftBeans.forEach(item2 => {
          goods_crafts.forEach(item3 => {
            if (item2.craft_id == item3.craft_id) {
              item.select_id = Number(item3.craft_id);
              item.craft_count = item3.craft_count;
              item.craft_price = item3.craft_price;
              item.order_craft_id = item3.order_craft_id;
            }
          });
        });
      });
      this.crafts_show = true;
      console.log(this.crafts);
    },

    // 重新选择工艺
    onCraftSelect(row, index) {
      let crafts = this.crafts;
      crafts[index].craftBeans.forEach(el => {
        if (el.craft_id == crafts[index].select_id) {
          crafts[index].craft_price = el.craft_price;
        }
      });
      this.crafts = JSON.parse(JSON.stringify(crafts));
    },
    //获取工艺列表
    getCrafts() {
      this.post("goodsInterfaces/v1.0/getCrafts").then(res => {
        let arr = res.data;
        arr.forEach(el => {
          el.craft_count = 1;
          el.select_id = "";
        });
        this.crafts = arr;
      });
    },
    // 订单详情
    getOrderDetail() {
      this.post("orderInterfaces/v1.0/getOrderMerchantsDetail", {
        order_merchants_id: this.$route.query.order_merchants_id
      }).then(res => {
        let order = res.data;
        this.initConfirmForm(order);

        this.loading = true;
      });
    },
    checkout() {
      //提交订单
      let order_detail = this.order_detail;
      let param = {
        order_id: order_detail.order_id,
        contract_type: order_detail.contract_type,
        pay_start_proportion: order_detail.pay_start_proportion,
        pay_ing_proportion: order_detail.pay_ing_proportion,
        pay_end_proportion: order_detail.pay_end_proportion,
        order_service_price: order_detail.order_service_price,
        order_actual_price: order_detail.order_actual_price,
        pay_day: order_detail.pay_day,
        json: JSON.stringify(order_detail.json),
        address_id: order_detail.address_id,
        is_invoice: order_detail.is_invoice,
        invoice_id: order_detail.invoice_id,
        contract_platform_imgs: order_detail.contract_platform_imgs.join(","),
        is_summit: 0
      };

      this.post("orderInterfaces/v1.0/sellConfirmOrder", param).then(res => {
        let order = res.data;
        this.initConfirmForm(order);
      });
    },
    initConfirmForm(order) {
      this.order_detail = order;
      this.order_detail.order_id = order.order_id;
      this.order_detail.contract_type = order.contract_type;
      this.order_detail.pay_start_proportion =
        order.pay_start_proportion == "0.00" ? "" : order.pay_start_proportion;
      this.order_detail.pay_ing_proportion =
        order.pay_ing_proportion == "0.00" ? "" : order.pay_ing_proportion;
      this.order_detail.pay_end_proportion =
        order.pay_end_proportion == "0.00" ? 100 : order.pay_end_proportion;
      this.order_detail.order_service_price =
        order.order_service_price == "0.00" ? "" : order.order_service_price;
      this.order_detail.order_actual_price = order.order_total_price;
      this.order_detail.address_id = order.orderAddressBean.address_id;
      this.order_detail.is_invoice = order.is_invoice;
      this.order_detail.invoice_id = order.orderInvoiceBean.invoice_id;

      this.order_detail.contract_platform_imgs = this.order_detail
        .contract_platform_imgs
        ? order.contract_platform_imgs.split(",")
        : [];

      //    工艺
      let craft = [];

      for (const goods of order.orderGoodsBeans) {
        if (goods.goods_type == 1) {
          let obj = {
            order_goods_id: goods.order_goods_id,
            orderCraftBeans: goods.orderCraftBeans
          };
          craft.push(obj);
        } else {
          let obj = {
            order_goods_id: goods.order_goods_id,
            orderCraftBeans: []
          };
          craft.push(obj);
        }
      }
      this.order_detail.json = craft;
    }
  },
  components: { NavBar, SearchBar, FooterBar, "up-load": Upload }
};
</script>

<style scoped lang="scss">
.order_detail {
  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .nav {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }

    .info_box {
      background-color: #fff;
      padding: 20px;

      .info {
        background-color: #fff;

        .order_list_item {
          &:nth-of-type(1) {
            width: 400px;
          }

          &:nth-of-type(2) {
            width: 130px;
          }

          &:nth-of-type(3) {
            width: 130px;
          }

          &:nth-of-type(4) {
            width: 130px;
          }

          &:nth-of-type(5) {
            width: 130px;
          }

          &:nth-of-type(6) {
            width: 130px;
          }

          &:nth-of-type(7) {
            width: 130px;
          }
        }

        .order-list {
          .order-item {
            border: 1px solid #e5e5e5;

            .top {
              background-color: #f0f6ff;
              padding: 14px;
            }

            .middle {
              border-bottom: 1px solid #e5e5e5;

              .order {
                .order_left {
                  border-right: 1px solid #e5e5e5;
                  border-bottom: 1px solid #e5e5e5;

                  &:last-child {
                    border-bottom: none;
                  }

                  .goods_img {
                    width: 80px;
                    height: 80px;
                  }
                }

                .operating {
                  p {
                    margin-top: 10px;

                    &:nth-of-type(1) {
                      margin-top: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .price_box {
        font-size: 14px;

        .price_item {
          padding: 0 20px;
          min-height: 50px;
          background-color: #f0f6ff;
          border-bottom: 1px solid #fff;

          .vip_order_imgs {
            width: 80px;
            height: 80px;
            margin-right: 10px;
          }
        }

        .pay_table {
          height: 100px;
          border: 1px solid #e5e5e5;

          .tr {
            height: 50px;
            border-bottom: 1px solid #e5e5e5;

            &:nth-of-type(2) {
              border-bottom: none;
            }

            .th {
              background-color: #f0f6ff;
              font-weight: 800;
            }

            .th,
            .td {
              font-size: 14px;
              text-align: center;
              line-height: 50px;
              height: 100%;
              border-right: 1px solid #e5e5e5;

              &:last-child {
                border-right: none;
              }
            }

            .td {
              width: 33.33%;
            }
          }
        }

        .contract_img {
          width: 150px;
          height: 150px;
          margin-right: 10px;
        }

        .receipt {
          width: 40%;
          border: 1px solid #e5e5e5;

          .top {
            padding: 20px;
            border-bottom: 1px solid #e5e5e5;
          }

          .bottom {
            padding: 30px 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/merchantsOrder/reply.vue